import React, { useState } from 'react';

import { sendNativeMessageAPI } from '@lib/native';
import { sendAiMessage } from '@lib/ai';
import { WEBVIEW } from '@constants/serviceConstants';

const LangChainTemplate = () => {
  const [msg, setMsg] = useState('');

  /**
   * AI 에이전트 조언 요청 및 응답 전송(for Test)
   */
  const getAiAdviceTest = (args) => {
    sendAiMessage(args.msg).then((res) => {
      sendNativeMessageAPI(WEBVIEW.SEND_CODE.AI_CHAT_TEST, { msg: res.content });
    });
  };

  const onClickTestLangChain = () => {
    sendAiMessage(msg).then((res) => {
      console.log(res.content);
    });
  };

  window.getAiAdviceTest = getAiAdviceTest;

  return (
    <div>
      webview..
      <br />
      <br />
      <br />
      <br />
      <textarea value={msg} onChange={(e) => setMsg(e.target.value)} />
      <div>
        <button style={{ width: '100%', height: '30px' }} onClick={onClickTestLangChain}>
          테스트!
        </button>
      </div>
    </div>
  );
};

export default LangChainTemplate;
